import { executeNetworkAsync } from "../../helper/handler/network";
import { clientAxiosInstance } from "../../types/swrFetcher";

export const authenticateUserController = async (
  email: string,
  password: string
) => {
  const networkCall = async () =>
    await clientAxiosInstance().post("/api/auth/authenticateUser", {
      email,
      password,
    });

  const [result, error] = await executeNetworkAsync(networkCall);
  return [result, error];
};
